export default __webpack_public_path__ + "static/media/leave.d1d420a0.png";